/* eslint-disable react/no-danger */
/*
 This is lightbox, for a react version of the already existing backbone view, and here are the links to the the ui-legacy file of previous lightbox
 https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsCampaignUI?path=%2Fprivate%2Fui-legacy%2FStaticResources%2FAdvertiser%2FStaticResourcesWeb%2FApplication%2FScripts%2Ftemplate%2Fshared%2Flightbox.jade&_a=contents&version=GBmaster
 https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsCampaignUI?path=%2Fprivate%2Fui-legacy%2FStaticResources%2FAdvertiser%2FStaticResourcesWeb%2FApplication%2FScripts%2Fmodule%2Fservice%2Fshared%2FlightboxService.js&_a=contents&version=GBmaster
*/
import $ from 'jquery';
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useState, useContext } from 'react';
import URI from 'urijs';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getUrlBuilders } from '@bingads-webui-clientcenter/url-builder-base';
import { MobileAppInstallPrompt, MobileAppInstallPromptWithUserGovernance } from '@bingads-webui-campaign-react/mobile-app-install-prompt';
import { GenericLightboxDialog } from './generic-lightbox-dialog';

const LightBoxContent = ({
  serverContext, preferenceService, permissions, customerId, contextUrl, userId, setLoading, onCancel,
}) => {
  const { scope } = useContext(ScopeContext);
  const accountId = scope.values.aid;
  const [selectedRadioVal, setSelectedRadioVal] = useState(false);
  const [forceHideDialog, setForceHideDialog] = useState(false);
  const keyName = `WebApp.Next.Lightbox.AccountCancellation.Checked.${accountId}`;
  const accountCancellationPreference = preferenceService.findByName(keyName);
  const {
    data: {
      canShow,
      title,
      subTitle,
      hasSubTitle = false,
      mainMessageBlock,
      subMessageBlock,
      midMessageBlock,
      btmMessageBlock,
      accountsInfoBlock,
      hasActionButton = false,
      hasCancelButton = false,
      actionButton = {},
      cancelButton = {},
      hasCheckbox = false,
      checkbox,
      hasAccCancelCheckbox = false,
      hasSecondActionButton = false,
      secondActionButton = {},
      isMobileAppInstallPrompt = false,
    } = {},
    loading: lightBoxLoading,
  } = useJsData(jsData =>
    jsData.ShowLightBox.find(customerId, {
      bypassCache: true,
      params: {
        uid: userId,
        aid: accountId,
        rurl: contextUrl,
      },
    }));

  const canShowLightbox = () => {
    if (isMobileAppInstallPrompt && (!permissions.dynamic.MobileAppInstallUserPrompt || _.get(serverContext, ['DynamicPermissions', 'PMaxLite'], false))) {
      return false;
    }
    if (_.isUndefined(canShow) || forceHideDialog) {
      return false;
    }
    if (hasAccCancelCheckbox && !_.isUndefined(accountCancellationPreference)) {
      return false;
    }
    return canShow;
  };

  const handleRadioClick = () => {
    setSelectedRadioVal(!selectedRadioVal);
  };

  const saveInPreferencesToNotShowAgain = () => {
    if (!_.isUndefined(preferenceService)) {
      preferenceService.set({
        Name: keyName,
        Data: true,
      });
    }
  };

  const notificationAction = (actionName) => {
    if (!_.isEmpty(actionName)) {
      const { NotificationUrlBuilder } = getUrlBuilders({
        ccBaseUrl: serverContext.Urls.ClientCenterBaseUrl,
        aidFetcher: () => accountId,
        cidFetcher: () => customerId,
        uidFetcher: () => userId,
        getDefaultIsShortUrl: _.constant(true),
      });
      $.advertiser.ajaxPost({
        url: new NotificationUrlBuilder().action(actionName).rurl(encodeURIComponent(window.location.href)).url,
        ignoreBeforeAjax: true,
        hideLoadingPanelOnSuccess: false,
        onAjaxError: $.noop,
        onAjaxComplete: $.noop,
        onJsonError: $.noop,
        xhrFields: {
          withCredentials: true,
        },
      });
    }
  };

  const handleClickButton = (url, actionName) => {
    if (!_.isEmpty(actionName)) {
      notificationAction(actionName);
    }
    if (url) {
      let newUrl = url;
      if (URI(url).is('relative')) {
        newUrl = URI(serverContext.Urls.RootUIUrl).resource(url).toString();
      }
      scope.history.push(newUrl);
    } else {
      setForceHideDialog(true);
    }
  };

  const handleClickActionButton = () => {
    if (!hasActionButton) {
      return;
    }
    handleClickButton(actionButton.url, actionButton.onClickActionName);
    if (hasAccCancelCheckbox && selectedRadioVal) {
      saveInPreferencesToNotShowAgain();
    }
  };

  const handleClickCancelButton = () => {
    onCancel();
    if (hasCancelButton) {
      handleClickButton(cancelButton.url, cancelButton.onClickActionName);
    }
    setForceHideDialog(true);
  };

  setLoading(lightBoxLoading);

  return canShowLightbox() ? ( // eslint-disable-line no-nested-ternary
    isMobileAppInstallPrompt ? ( // eslint-disable-line no-nested-ternary
      _.result(serverContext, ['Permissions', 'IsCentralizedPopupManagementEnabled']) ?
        <MobileAppInstallPromptWithUserGovernance
          hidden={() => false}
          handleClickCancelButton={handleClickCancelButton}
          featureName="MobileAppInstallPrompt"
        /> : <MobileAppInstallPrompt
          hidden={() => false}
          handleClickCancelButton={handleClickCancelButton}
        />
    ) : <GenericLightboxDialog
      serverContext={serverContext}
      hidden={() => false}
      handleClickCancelButton={handleClickCancelButton}
      title={title}
      hasSubTitle={hasSubTitle}
      subTitle={subTitle}
      hasCancelButton={hasCancelButton}
      cancelButton={cancelButton}
      mainMessageBlock={mainMessageBlock}
      subMessageBlock={subMessageBlock}
      midMessageBlock={midMessageBlock}
      btmMessageBlock={btmMessageBlock}
      accountsInfoBlock={accountsInfoBlock}
      hasCheckbox={hasCheckbox}
      checkbox={checkbox}
      handleRadioClick={handleRadioClick}
      selectedRadioVal={selectedRadioVal}
      hasActionButton={hasActionButton}
      handleClickActionButton={handleClickActionButton}
      actionButton={actionButton}
      hasSecondActionButton={hasSecondActionButton}
      handleClickButton={handleClickButton}
      secondActionButton={secondActionButton}
    />
  ) : null;
};

LightBoxContent.propTypes = {
  serverContext: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  preferenceService: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  customerId: PropTypes.number.isRequired,
  contextUrl: PropTypes.string.isRequired,
  userId: PropTypes.number,
  setLoading: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

LightBoxContent.defaultProps = {
  userId: null,
};

export const LightBoxDialog = withRouter(LightBoxContent);
